import { DetailEditorPropsByYear } from '../types'
import { WaterPumpIrrigationEditor } from './WaterPumpIrrigationEditor'

export const WaterPumpIrrigationEditorSimple = (props: DetailEditorPropsByYear) => (
  <WaterPumpIrrigationEditor {...props} simple />
)
